export default __webpack_public_path__ + "static/media/RTCCサービス新旧対照表.b5562eed.pdf";